import { Types } from '../actions/tracking';

export default function trackingReducer(state = {tracking: {}, loading: false, success: false, error: false}, action) {
    switch (action.type) {
        case Types.TRACKING_GET_REQUEST:
            return {...state, loading: true }
        case Types.TRACKING_GET_SUCCEEDED:
            return {...state, tracking: action.tracking, loading: false, success: true, error: false};
        case Types.TRACKING_GET_ERROR:
            return {...state, loading: false, success: false, error: action.err,};
        default:
            return state;
    }
}